import * as React from "react";
import { cn } from "../util";
import { PuntoNaranja } from "../marca/Wordmark";

/** Estado vacío: título en Bitter con punto naranja, texto corto, acción opcional. */
export function Vacio({
  titulo,
  texto,
  accion,
  className,
}: {
  titulo: string;
  texto?: string;
  accion?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-start gap-3 border border-dashed border-linea-fuerte p-8",
        className,
      )}
    >
      <h3 className="font-titulo text-xl font-bold">
        {titulo}
        <PuntoNaranja />
      </h3>
      {texto && <p className="max-w-prose font-ui text-sm text-tinta-tenue">{texto}</p>}
      {accion}
    </div>
  );
}

/** Esqueleto de carga: bloques planos, sin brillo. */
export function Esqueleto({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse bg-fondo-alzado", className)} {...props} />;
}

export function EsqueletoTabla({ filas = 5, columnas = 4 }: { filas?: number; columnas?: number }) {
  return (
    <div className="space-y-2" aria-busy="true" aria-label="Cargando">
      {Array.from({ length: filas }).map((_, i) => (
        <div key={i} className="flex gap-3">
          {Array.from({ length: columnas }).map((_, j) => (
            <Esqueleto key={j} className="h-5 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
